(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name commons.controller:ReplacePairingModalCtrl
   *
   * @description
   *
   */
  angular
    .module('crewing')
    .controller('ReplacePairingModalCtrl', ReplacePairingModalCtrl);

  function ReplacePairingModalCtrl($timeout, CrewingHelper, MessageService, modalParams, $uibModalInstance, EventManagerService, RemoteService, PopupManager) {
    var vm = this;

    vm.model = {
      patternData: null,
      selectedPattern: null,
      isRequest: false,
      isShowPortalVisible:false,
      isShowPortalEnabled:false,
      isShowPortal:false,
      isCallFromDayOff: false,
      isObsFlight: false,
      isHideinCrewPortal: false,
      showNoRecord: false,
      patternTypes : null,
      pairingBases : null,
      searchByPairingBase : '',
      setDefaultBase : false,
      crewScheduleBlockId : null,
      previousCrewScheduleBlockId : null,
      checkInDate : null,
      checkInTime : null,
      patternName : null,
      isTargetHoursValid : true,
      isAirportRecencyOverridden : false
    };

    vm.closeMe = function () {
      $uibModalInstance.close();
    };

    getPairings();
    getPairingBases();
    setDefaultBase();

    function getPairings() {
      console.log("getPairings :", modalParams.event);
      vm.model.crewScheduleBlockId = modalParams.crewScheduleBlockId;
      console.log("vm.model.crewScheduleBlockId :", modalParams.duty.crewScheduleBlockId);
      vm.model.isShowPortal = angular.isUndefined(modalParams.showInCrewPortalParams)?false:modalParams.showInCrewPortalParams.value;
      vm.model.isShowPortalVisible = angular.isUndefined(modalParams.showInCrewPortalParams)?false:modalParams.showInCrewPortalParams.isVisible;
      vm.model.isShowPortalEnabled = angular.isUndefined(modalParams.showInCrewPortalParams)?false:modalParams.showInCrewPortalParams.isEnabled;
      vm.model.previousCrewScheduleBlockId = modalParams.duty.crewScheduleBlockId;
      vm.model.checkInDate = modalParams.duty.checkInDate;
      vm.model.checkInTime = modalParams.duty.checkInTime;
      vm.model.patternName = modalParams.duty.patternName;

      CrewingHelper.searchPatternData(modalParams.crew.crewDTO.crewProfileId, modalParams.duty.checkInDate, modalParams.event, modalParams.duty.crewScheduleBlockId,
        function (data) {
          vm.model.patternData = data.patternDTOs;
          vm.model.targetHoursTolerance = data.targetHoursTolerance;
          vm.model.crewTypesForTargetHrVal = data.crewTypesForTargetHrVal.split(",");
          vm.model.patternTypes = getPatternTypes(vm.model.patternData);
          vm.model.showNoRecord = vm.model.patternData.length == 0;
        },
        function (msg) {
          MessageService.error(msg);
        }
      )
    }

    function getCrewBaseAssignment() {
      var request = createCrewBaseAssignmentRequest(modalParams.crew.crewDTO.crewProfileId, modalParams.duty.checkInDate);

      RemoteService.crewBaseAssignmentByDate(request).then(
        function (data) {
          if(vm.model.setDefaultBase){
            vm.model.searchByPairingBase = data.crewBaseAssignmentAdaptDTO.base;
          }
        },
        function (msg) {
          MessageService.error(msg);
        }
      );
    }

    function setDefaultBase(){
      RemoteService.isSetDefaultBase().then(
        function (response) {
          if(!!response && !!response.appParamValueDTO){
            vm.model.setDefaultBase = (("Y") == response.appParamValueDTO.paramValue) ? true : false;
          } else {
            vm.model.setDefaultBase = false;
          }
          getCrewBaseAssignment();
        },
        function (msg) {
          MessageService.error(msg);
          getCrewBaseAssignment();
        }
      );
    }

    function getPairingBases(patternData){
      RemoteService.getBaseList().then(
        function (response) {
          vm.model.pairingBases = prepareBaseList(response);
        },
        function (msg) {
          MessageService.error(msg);
        }
      );
    }

    function prepareBaseList(data) {
      var result = [];
      var groups = _.groupBy(data.baseListDTOs,'airPortCode');
      angular.forEach(Object.keys(groups), function (tName) {
        result.push(tName)
      });
      return result
    }

    function createCrewBaseAssignmentRequest (crewProfileId, date) {
      return {
        crewProfileId: crewProfileId,
        localDate: date
      };
    };

    function getPatternTypes(patternData){
      var result = [];
      var groups = _.groupBy(patternData,'patternType');
      angular.forEach(Object.keys(groups), function (tName) {
        result.push({
          name :tName.substr(0,1).toUpperCase()+tName.substr(1).toLowerCase()
        })
      });
      return result
    }

    function getPatternById(paringID) {
      CrewingHelper.getPatternById(paringID,
        function (data) {
        },
        function (msg) {
          MessageService.error(msg)
        }
      );
    }

    vm.onReplacePairingClick = function () {
      console.log("clicked ", vm.model.selectedPattern);
      checkAirportRecency();
    };

    function proceedReplacePairingAfterAirportRecencyCheck(){
          var deletingDutyflyingMins = modalParams.deletingDutyflyingMins;
          var flyingMins = vm.model.selectedPattern.flyingMins;
          var MESSAGES=[];

          if(flyingMins > 0 && modalParams.showInCrewPortalParams.value && parseFloat(modalParams.crewDTOs[0].targetDuration) > 0 && vm.model.crewTypesForTargetHrVal.includes(modalParams.crew.crewType)
              && (parseFloat(modalParams.crewDTOs[0].flyingDuration) - (parseFloat(deletingDutyflyingMins)/60) + (parseFloat(flyingMins)/60))> (parseFloat(modalParams.crewDTOs[0].targetDuration) + parseFloat(vm.model.targetHoursTolerance))){
            var hourDifference = ((parseFloat(modalParams.crewDTOs[0].flyingDuration) - (parseFloat(deletingDutyflyingMins)/60) + (parseFloat(flyingMins)/60)) - (parseFloat(modalParams.crewDTOs[0].targetDuration) + parseFloat(vm.model.targetHoursTolerance))).toString();
            var hours = Math.floor(hourDifference).toString();
            var minutes = Math.round((hourDifference - hours) * 60).toString();
            MESSAGES=["Crew Flying Hours exceeds Target Hours by "+ hours +" hours and "+ minutes +" minutes. Are you sure to continue?"];

            var details = {
                      title: 'Confirmation',
                      messages: MESSAGES
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignPairing);
          }else{
            if (!!vm.model.selectedPattern) {
              if (CrewingHelper.isDistributionCheckApplicable(vm.model.selectedPattern.patternType)) {
                CrewingHelper.checkDistributionWarnings(modalParams.crew.crewDTO.crewTypeMasterCode, vm.model.selectedPattern.patternId, modalParams.crew.crewDTO.crewProfileId, false, proceedReplacePairing, {});
              }
            } else {
              MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_WARNING);
            }
          }
    }

    function checkAirportRecency() {
      var dutyStartLocation = vm.model.selectedPattern ? vm.model.selectedPattern.pairingBase : '';
      var crewProfileId = modalParams.crew.crewDTO ? modalParams.crew.crewDTO.crewProfileId : '';
      var dutyStartDate = vm.model.selectedPattern ? vm.model.selectedPattern.startDate + ' ' + vm.model.selectedPattern.startTime : '';
      var patternId = vm.model.selectedPattern ? vm.model.selectedPattern.patternId : 0;

      if (modalParams.crew.crewDTO.crewTypeMasterCode === "FC") {
        CrewingHelper.isViolatingAirportRecency(crewProfileId, dutyStartDate, patternId, function (updateResponse) {
          vm.model.isAirportRecencyOverridden = false;
          console.log("date :", dutyStartDate);

          if(!updateResponse.overridingAuthorized){
            var details = {
              title: 'Expired',
              messages: ["Airport Recency Violated. ", "Airport(s): " + updateResponse.recencyExpiredAirports, "Sorry, You do not have authorization to override"]
            };

            PopupManager.openModal('WARNING', details, confirmtoProceed);

            function confirmtoProceed(param) {
              if (param === 'YES') {
              }
            }
          }

          else if(!updateResponse.recencyMet){
            var details = {
              title: 'Confirmation',
              messages: [MessageService.MESSAGES.CREWING.AIRPORT_RECENCY_VIOLATED, "Airport(s): " + updateResponse.recencyExpiredAirports]
            };

            PopupManager.openModal('OVERRIDE_CONFIRM', details, confirmtoProceed);

            function confirmtoProceed(param) {
              if (param === 'YES') {
                vm.model.isAirportRecencyOverridden = true;
                proceedReplacePairingAfterAirportRecencyCheck();
              }
            }
          }
          else if(updateResponse.recencyExpiringSoon) {
            var details = {
              title: 'Warning',
              messages: ["Airport Recency Violating Soon For Airport(s) ", updateResponse.recencyExpiringSoonAirports]
            };

            PopupManager.openModal('WARNING', details, confirmtoProceed);

            function confirmtoProceed(param) {
              if (param === 'YES') {
                proceedReplacePairingAfterAirportRecencyCheck();
              }
            }
          }
          else {
            proceedReplacePairingAfterAirportRecencyCheck();
          }

        }, function (msg) {
          MessageService.error(msg);
        });
      }
      else {
        proceedReplacePairingAfterAirportRecencyCheck();
      }


    }

    function confirmAssignPairing(pass){
      if(pass=='YES') {
        vm.model.isTargetHoursValid = false;
        if (!!vm.model.selectedPattern) {
          if (CrewingHelper.isDistributionCheckApplicable(vm.model.selectedPattern.patternType)) {
            CrewingHelper.checkDistributionWarnings(modalParams.crew.crewDTO.crewTypeMasterCode, vm.model.selectedPattern.patternId, modalParams.crew.crewDTO.crewProfileId, false, proceedReplacePairing, {});
          } else {
            proceedReplacePairing();
          }
        } else {
          MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_WARNING);
        }
      }
    }

    vm.onSelectPairing = function (pattern) {
      vm.model.selectedPattern = pattern;
    };

    vm.onPairingOpen = function (pattern) {
      pattern.isOpen = !pattern.isOpen;
      if (pattern.isOpen && angular.isUndefined(pattern.moreDetail)) {
        CrewingHelper.getPatternById(pattern.patternId,
          function (data) {
            pattern.moreDetail = data;
          },
          function (msg) {
            MessageService.error(msg);
          }
        )
      }
    };


    function validateAssignCrewCount(){
      var details = {
        title: 'Confirmation',
        messages: [MessageService.MESSAGES.CREWING.CREW_REQUIREMENT_EXCEEDS]
      };
      PopupManager.openModal('CONFIRM_DIALOG', details, confirmCrewRequirementExceeds);

      function confirmCrewRequirementExceeds(param) {
        if(param === 'YES'){
          replacePairing();
        }else {
          return false;
        }
      }

    }

    function proceedReplacePairing() {
      if(!!vm.model.selectedPattern.assignedCrew && !!vm.model.selectedPattern.requiredCrew
        && vm.model.selectedPattern.assignedCrew >= vm.model.selectedPattern.requiredCrew){
        replacePairing();
      }else{
        replacePairing();
      }
    }

    function replacePairing(){
      CrewingHelper.replacePattern(
        modalParams.crew.crewDTO.crewProfileId,
        vm.model.selectedPattern,
        vm.model.isRequest,
        vm.model.isCallFromDayOff,
        true,
        false,
        vm.model.isShowPortal,
        vm.model.crewScheduleBlockId,
        vm.model.previousCrewScheduleBlockId,
        vm.model.checkInDate,
        vm.model.checkInTime,
        vm.model.patternName,
        vm.model.isTargetHoursValid,
        modalParams.crewDTOs,
        vm.model.isAirportRecencyOverridden,
        function success(data) {
          var modalData = {
            regulationDetails: data,
            crewProfileId: modalParams.crew.crewDTO.crewProfileId,
            crewTypeMasterCode : modalParams.crew.crewDTO.crewTypeMasterCode,
            pattern: vm.model.selectedPattern,
            isRequest: vm.model.isRequest,
            isCallFromDayOff: vm.model.isCallFromDayOff,
            isObsFlight: vm.model.isObsFlight,
            isHideinCrewPortal: vm.model.isHideinCrewPortal,
            isShowCrewPortal: vm.model.isShowPortal,
            crewScheduleBlockId :vm.model.crewScheduleBlockId,
            isTargetHoursValid: vm.model.isTargetHoursValid,
            isAirportRecencyOverridden: vm.model.isAirportRecencyOverridden,
            isRestrictedForAssigningIllegalDuties :!!data.restrictedForAssigningIllegalDuties,
            isRestrictedOperation : !!data.restrictedOperation
          };
          $uibModalInstance.close(modalData);
        },
        function fail(msg) {
          MessageService.error(msg);
        });
    }

  }
}());
